/* Crystal Quest site footer, "Summit" (sections/cq-footer.liquid). Vanilla JS, ported from the round 14 mock.
   1. Link columns: open lists on tablet and desktop, accordions on phones (button + aria-expanded). The mode follows
      the footer's own width (the same 640 px rule as the CSS container query), not the window.
   2. Depth: sky, statement, range and wave move at different speeds while the summit is on screen (max 14 px).
   3. Signature: the wave draws itself once when the summit comes into view, after the photo layers have loaded
      (or after 2.5 s), so it never draws over an empty sky.
   4. Newsletter: Shopify's customer form. Checks the email and the consent box with a clear message; a valid form
      submits normally to Shopify (no third-party service).
   Reduced motion: no parallax, no reveal, the finished still is shown. Every [data-cqf-a] root is set up, and
   Shopify's section load and unload events set it up again or tear it down. */
(function () {
  'use strict';
  var PHONE_MAX = 639;

  function init(root) {
    if (!root || root.__cqfA) return;
    var off = [];                                   /* teardown steps */
    function listen(t, type, fn, opt) { t.addEventListener(type, fn, opt); off.push(function () { t.removeEventListener(type, fn, opt); }); }

    /* 1. columns: phone mode is decided by the footer's width */
    var cols = Array.prototype.slice.call(root.querySelectorAll('.cqf-a__col')).map(function (c) {
      var btn = c.querySelector('.cqf-a__col-btn');
      return { btn: btn, list: btn && document.getElementById(btn.getAttribute('aria-controls')) };
    }).filter(function (c) { return c.btn && c.list; });
    function setOpen(c, open) {
      c.btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      c.list.hidden = !open;
    }
    var mode = null;
    function syncCols() {
      var next = root.getBoundingClientRect().width <= PHONE_MAX ? 'phone' : 'wide';
      if (next === mode) return;                    /* only act when the mode changes (opening a column also resizes the root) */
      mode = next;
      cols.forEach(function (c) { setOpen(c, mode === 'wide'); });
    }
    cols.forEach(function (c) {
      listen(c.btn, 'click', function () { setOpen(c, c.btn.getAttribute('aria-expanded') !== 'true'); });
    });
    syncCols();
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(syncCols); ro.observe(root); off.push(function () { ro.disconnect(); });
    } else { listen(window, 'resize', syncCols); }

    /* 4. newsletter: our messages instead of the browser's bubbles; a valid form posts to Shopify as usual */
    var form = root.querySelector('[data-cqf-a-form]');
    if (form) {
      var email = form.querySelector('input[type="email"]');
      var ok = form.querySelector('input[type="checkbox"]');
      var note = form.querySelector('.cqf-a__note');
      if (email && ok && note) {
        form.noValidate = true;                     /* without JS the native checks (required email and consent) apply */
        var flag = function (el, msg) {
          note.textContent = msg;
          el.setAttribute('aria-invalid', 'true');
          el.setAttribute('aria-describedby', note.id);
          el.focus();
        };
        var clear = function (el) { el.removeAttribute('aria-invalid'); el.removeAttribute('aria-describedby'); };
        listen(form, 'submit', function (e) {
          clear(email); clear(ok);
          if (!email.value.trim()) { e.preventDefault(); flag(email, 'Enter your email address to join.'); return; }
          if (!email.checkValidity()) { e.preventDefault(); flag(email, 'Enter a valid email address.'); return; }
          if (!ok.checked) { e.preventDefault(); flag(ok, 'Tick the box to agree to marketing emails.'); return; }
          note.textContent = '';
        });
        listen(email, 'input', function () { clear(email); });
        listen(ok, 'change', function () { clear(ok); });
      }
    }

    /* photo layers: placeholder until loaded, then a short fade (CSS); resolves when both are ready */
    var layerEls = Array.prototype.slice.call(root.querySelectorAll('.cqf-a__layer'));
    var ready = Promise.all(layerEls.map(function (layer) {
      var img = layer.querySelector('img');
      return new Promise(function (resolve) {
        if (!img) { resolve(); return; }
        function done() { layer.classList.add('is-loaded'); resolve(); }
        if (img.complete && img.naturalWidth) { done(); return; }
        listen(img, 'load', function () {
          if (img.decode) img.decode().then(done, done); else done();
        });
        listen(img, 'error', resolve);              /* keep the placeholder; do not hold the reveal */
      });
    }));
    root.classList.add('cqf-a--js');

    root.__cqfA = { destroy: function () {
      off.forEach(function (f) { f(); });
      root.classList.remove('cqf-a--js', 'cqf-a--armed', 'cqf-a--revealed', 'cqf-a--live');
      delete root.__cqfA;
    } };

    /* 2 and 3 need motion and IntersectionObserver */
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduce.matches || !('IntersectionObserver' in window)) return;

    var summit = root.querySelector('.cqf-a__summit');
    if (!summit) return;
    var layers = Array.prototype.slice.call(root.querySelectorAll('[data-depth]'));
    var active = false, queued = false;

    function frame() {
      queued = false;
      var r = summit.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var p = (vh - r.top) / (vh + r.height);          /* 0 entering at the bottom, 1 leaving at the top */
      p = Math.max(0, Math.min(1, p));
      var t = (p - 0.5) * 2;                            /* -1 .. 1, composed still at 0 */
      for (var i = 0; i < layers.length; i++) {
        var k = parseFloat(layers[i].getAttribute('data-depth')) || 0;
        layers[i].style.transform = 'translate3d(0,' + (t * k).toFixed(2) + 'px,0)';
      }
    }
    function request() { if (active && !queued) { queued = true; window.requestAnimationFrame(frame); } }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        active = e.isIntersecting;
        root.classList.toggle('cqf-a--live', active);   /* will-change only while the parallax runs */
        if (active) request();
      });
    }, { rootMargin: '80px 0px' });
    io.observe(summit);
    off.push(function () { io.disconnect(); });
    listen(window, 'scroll', request, { passive: true });
    listen(window, 'resize', request);

    root.classList.add('cqf-a--armed');
    var gate = Promise.race([ready, new Promise(function (r) { setTimeout(r, 2500); })]);
    var once = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        once.disconnect();
        gate.then(function () { if (root.__cqfA) root.classList.add('cqf-a--revealed'); });
      });
    }, { threshold: 0.35 });
    once.observe(summit);
    off.push(function () { once.disconnect(); });
  }

  function initIn(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-cqf-a]'), init);
  }
  function destroyIn(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-cqf-a]'), function (r) { if (r.__cqfA) r.__cqfA.destroy(); });
  }
  initIn(document);
  document.addEventListener('shopify:section:load', function (e) { initIn(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroyIn(e.target); });
})();
